import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from '../../toaster/toaster.service';
import { JobbingService } from '../../Jobbing/jobbing.service';
import { Job } from '../../Jobbing/models/Job';
import { JobDetailBoxComponent } from './components/job-detail-box/job-detail-box.component';
import { JobFromLocationDetailsBoxComponent } from './components/job-from-location-details-box/job-from-location-details-box.component';
import { JobToLocationDetailsBoxComponent } from './components/job-to-location-details-box/job-to-location-details-box.component';
import { JobProductDetailsBoxComponent } from './components/job-product-details-box/job-product-details-box.component';
import { JobStatus } from '../../Jobbing/models/JobStatus';

@Component({
  selector: 'app-jobbing-job-eye-view-modal',
  standalone: true,
  imports: [JobDetailBoxComponent, JobFromLocationDetailsBoxComponent, JobToLocationDetailsBoxComponent, JobProductDetailsBoxComponent],
  templateUrl: './jobbing-job-eye-view-modal.component.html',
  styleUrl: './jobbing-job-eye-view-modal.component.scss'
})
export class JobbingJobEyeViewModalComponent implements OnChanges, OnInit {

  @Input()
  jobId: number | null = null;

  isLoading: boolean = false;
  jobDetails: Job | null = null;
  jobStatus: JobStatus;

  constructor(protected activeModal: NgbActiveModal, private jobbingService: JobbingService, private toasterService: ToasterService) 
  { 
    this.jobStatus = {
            statusId: 0,
            name: "",
            short: "",
            code: "",
            colour: "",
            hex: ""
        }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobId']) {
      this.jobId = changes['jobId'].currentValue
      this.loadJobDetails();
    }
  }

  ngOnInit(): void {
    this.loadJobDetails();
  }

  loadJobDetails() {
    this.isLoading = true;
    if (!this.jobId) {
      this.toasterService.show({
        text: 'No job id provided',
        classname: 'bg-danger text-light',
        delay: 5000
      });
      this.activeModal.dismiss();
    } else {
      this.jobbingService.getJobDetails(this.jobId).subscribe(job => {
        this.jobDetails = job;
        const movement = this.jobbingService.getCurrentMovement(this.jobDetails.movements);
        const movementStatus = this.jobbingService.getCurrentMovementStatus(movement.movementStatus);
        this.jobStatus = movementStatus.status;
        this.isLoading = false;
      });
    }
  }

}
